import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-undo-icon',
  templateUrl: './text-undo.component.html'
})
export class TextUndoComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
